import { type APITriplet, RDK_NAMESPACE } from '$lib/resource-type';

export const isBuiltinAPI = (
  api: APITriplet,
  expectedSubtype?: string
): boolean => {
  return (
    api.namespace === RDK_NAMESPACE &&
    (expectedSubtype === undefined || api.subtype === expectedSubtype)
  );
};
